import React from 'react'
import { useIntl } from 'react-intl'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import { ShevronDownIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronDownIcon'
import type { TIconPosition } from '@/components/ui/Button/interfaces'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { getRegionMixedGenitiveAndDativeDeclination } from '@/utils/regions'

export const useRegionSelect = () => {
  const { formatMessage } = useIntl()
  const isMobile = useDeviceType()

  return {
    formatRegionName: (regionName?: string, genitiveCase?: boolean) => {
      if (regionName === undefined) return formatMessage({ id: 'userRegionSelectPicker.empty' })

      return genitiveCase ? getRegionMixedGenitiveAndDativeDeclination(regionName) : regionName
    },

    selectorIcon: {
      iconPosition: 'right' as TIconPosition,
      iconProps: {
        component: <ShevronDownIcon />,
        className: `userRegionSelectPicker${isMobile ? 'Mobile' : 'Desktop'}__icon`,
        style: { color: 'currentColor' },
        size: isMobile ? EIconSize.S : EIconSize.L,
      },
    },
  }
}
